import {createSlice} from '@reduxjs/toolkit';

const initialState = {
   video_upload : null
};

const video_upload_slice = createSlice ({
  name: 'video_upload_status',
  initialState,
  reducers: {
    set_video_blob:(state,action)=>{
        state.video_upload=action.payload;
    },
    set_video_upload_status: (state, action) => {
      
    },
  },
});

export const {set_video_blob} = video_upload_slice.actions;

export default video_upload_slice.reducer;
